import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { encrypt } from "../Utils/Encryption";
import { GoLinkExternal } from "react-icons/go";
import { Link } from "react-router-dom";

const LineCompare = ({ metricData }) => {
  const coordinates_data = JSON.parse(
    metricData?.comparison_coordinates || "{}"
  );

  const [chartData] = useState({
    series: [
      {
        name:
          coordinates_data?.visualization_data?.datasets?.[0]?.label ||
          "Metric 1",
        data: metricData?.value?.map((item) => Number(item?.metric_1)) || [],
      },
      {
        name:
          coordinates_data?.visualization_data?.datasets?.[1]?.label ||
          "Metric 2",
        data: metricData?.value?.map((item) => Number(item?.metric_2)) || [],
      },
    ],
    options: {
      chart: {
        type: "line",
        height: 350,
        zoom: {
          enabled: true,
        },
        toolbar: {
          show: true,
        },
      },
      colors: ["#3a80c2", "#b1c74eff"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      xaxis: {
        categories:
          metricData?.value?.map((item) => {
            const date = new Date(item?.name);
            return `${date.toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "short",
            })}`;
          }) || [],
        title: {
          text: coordinates_data?.visualization_data?.xAxis || "X-Axis",
          style: {
            fontWeight: "",
            color: "#666",
            fontSize: "16px",
            fontFamily: "sans-serif",
          },
        },
      },
      yaxis: {
        title: {
          text: coordinates_data?.visualization_data?.yAxis || "Y-Axis",
          style: {
            fontWeight: "",
            color: "#666",
            fontSize: "16px",
            fontFamily: "sans-serif",
          },
        },
      },
      tooltip: {
        x: {
          format: "dd MMM yyyy",
        },
        y: {
          formatter: (val) =>
            `${val} ${coordinates_data?.visualization_data?.value_type || ""}`,
        },
      },
    },
  });

  return (
    <div className="col-12 h-100 ChartData">
      <div className="dashboardCharttitleContainer">
        {metricData?.child && metricData?.pk_comparison_data_id ? (
          <Link
            to={`/dashboard/comparisonchildmetric/${
              metricData?.comparison_name
            }/${encrypt(metricData?.pk_comparison_data_id?.toString())}`}
            className="dashboardCharttitle dashboardCharttitleActive"
          >
            <span className="text-md">{metricData?.comparison_name}</span>
            <GoLinkExternal className="externelLink" />
          </Link>
        ) : (
          <div className="dashboardCharttitle">
            <span className="text-md">{metricData?.comparison_name}</span>
          </div>
        )}
      </div>

      <div className="dashboardChart col-12">
        <ReactApexChart
          options={chartData?.options}
          series={chartData?.series}
          type="line"
          height={350}
          width="100%"
          className="charts"
        />
      </div>
    </div>
  );
};

export default LineCompare;
